import { LinearProgress, Theme, Typography, linearProgressClasses, useTheme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { round } from "../utils/numbers";

interface FatProgressBarProps {
  current: number;
  target: number;
  unit: string;
  usePercent?: boolean;
  error?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    fatProgressContainer: {
      width: 60,
      flexShrink: 0,
      gridTemplateRows: "16px",
      gridTemplateColumns: "1fr",
      marginLeft: theme.spacing(1),
      display: "grid",
    },
    fatProgressLabel: {
      zIndex: 1,
      gridRowStart: 1,
      gridColumnStart: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    root: {
      height: "inherit",
    },
    error: {
      backgroundColor: theme.palette.error.dark,
    },
  })
);

export const FatProgressBar = ({ current, target, unit, usePercent = false, error = false }: FatProgressBarProps) => {
  const {
    palette: { info },
  } = useTheme();
  const value = (100 * current) / target;
  const classes = useStyles();
  return (
    <div className={classes.fatProgressContainer}>
      <LinearProgress
        sx={{
          height: "inherit",
          borderRadius: "3px",
          gridRowStart: 1,
          gridColumnStart: 1,
          [`&.${linearProgressClasses.colorPrimary}`]: {
            backgroundColor: info.lighter,
          },
          [`& .${linearProgressClasses.bar}`]: {
            backgroundColor: info.light,
          },
        }}
        variant="determinate"
        value={Math.min(100, value)}
      />
      <div className={classes.fatProgressLabel}>
        <Typography variant="subtitle1">{usePercent ? `${round(value, 0)}%` : `${current}/${target}${unit}`}</Typography>
      </div>
    </div>
  );
};

